import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { GlobalModalRenderer } from "./components/layout/global-modal-renderer";
import { GlobalDrawerRenderer } from "./components/layout/global-drawer-renderer";
import { GlobalPopoverRenderer } from "./components/layout/global-popover-renderer";
import useRefreshAuth from "./lib/hooks/useRefreshAuth";

export default function App() {
  useRefreshAuth();

  return (
    <>
      <RouterProvider router={router} />
      <GlobalModalRenderer />
      <GlobalDrawerRenderer />
      <GlobalPopoverRenderer />
    </>
  );
}